<faxe-page-layout showClock=true>
  <form [formGroup]="formGroup" class="action-page-form">
    <mat-card appearance="outlined" class="ctx-large action-card">
      <faxe-page-title></faxe-page-title>
      <faxe-input-form #inputstart
                       label="Ryttarnummer"
                       formCtrlName="start"
                       [parentFormGroup]="formGroup"
                       (input)="onInput()"
                       [inputAutoFocus]=true
                       [requiredInput]=true
                       (keydown.enter)='onStart()'>
      </faxe-input-form>

      <button
        type="button"
        [disabled]="startPending"
        mat-raised-button
        color="primary"
        class="wide"
        (click)="onStart()">
        START
      </button>
    </mat-card>
    <section class="history-panel">
      <faxe-rolling-hist-list
        [listItems]="listItems"
      ></faxe-rolling-hist-list>
    </section>
  </form>
</faxe-page-layout>
